export const updateNewTeam = 'updateNewTeam';
export const updateIsAddTeamClicked = 'updateIsAddTeamClicked';
export const updateTeams = "updateTeams";
export const updateIsEditTeamClicked = "updateIsEditTeamClicked";
export const updateTeamsDataTable = "updateTeamsDataTable";
export const updateIsViewTeamClicked = "updateIsViewTeamClicked";

